export default "__VITE_ASSET__ck4YBGNl__"